import { LinksTutoriaisListaType } from "../types"
import { setListaFiltered } from "../Reducers/LinksTutoriaisReducer"

export default function filterListas(dispatch: Function, lista: LinksTutoriaisListaType[] | null, fieldFiltered: string) {
    if (!lista) {
        dispatch(setListaFiltered(null))
        return
    }
    if (!fieldFiltered.trim()) {
        dispatch(setListaFiltered(lista))
        return
    }
    const termo = fieldFiltered.toLowerCase()
    const filtered = lista.filter((item) => item.nome.toLowerCase().includes(termo))
    dispatch(setListaFiltered(filtered))
}
